import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertComponent } from 'src/app/pages/alert/alert.component';
import { AppService } from 'src/app/services/app/app.service';

@Injectable({
  providedIn: 'root'
})

export class RoleGuard implements CanActivate {
  private roleData: Object = {
    company: ['dashboard','user_management', 'dept_management','inh_course' ,'course_builder', 'course_playlist', 'notice', 'certificate',
      'forum', 'staff_survey', 'manage_package', 'upload_document', 'play_list', 'offer_package'],
    individual: ['individual', 'ind-dashboard', 'courses', 'my_courses', 'course_builder', 'ind_certificate_management', 'purchase_history', 'course_preview', 'course_detail', 'manage_package'],
    manager: [] 
    // manager: ['manager','manager_dashboard','manager_employee_management','manager_coursework_management','manager_event_management','department_management','course_dashboard','course_builder','course_playlist','important_notice','certificate_management','company_forum','staff_survey','new_recruitment']
  }
  private loggedUserRole!: string;
  public userAccessMenu;
  constructor(private appService: AppService, private router: Router,  private dialog: MatDialog) {}

  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let sidebar_type;
    let userObj
    if (this.appService.getData('training-portal.userInfo')) {
      userObj = JSON.parse(this.appService.getData('training-portal.userInfo'))
      this.loggedUserRole = userObj['group_type']
      if (this.loggedUserRole === 'manager') {

        if(userObj.access != null){

          let acc = JSON.parse(userObj?.access)

          if(acc.length > 0){
            this.roleData['manager'] = JSON.parse(userObj?.access).map(item => {
              if (item === 'dashboard') return 'manager_dashboard';
              if (item === 'user_management') return 'manager_employee_management';
              if (item === 'document_management') return 'upload_document';
              // if (item === 'course_dashboard') return 'inh_course';
              if (item === 'important_notice') return 'notice';
              if (item === 'company_forum') return 'forum';
              if (item === 'certificate_management') return 'certificate';
              if (item === 'department_management') return 'dept_management';
              if (item === 'new_recruitment') return 'recruitment';

              // if (item === 'course_builder') return 'course_builder';
              if (item === 'course_playlist') return 'course_playlist';
              if (item === 'staff_survey') return 'staff_survey';
              if (item === 'quick_task') return 'qui_task';
              if (item === 'workflow') return 'workflow';
              if (item === 'usr_event') return 'user_event';
              if (item === 'time_clock') return 'time_management';
              if (item === 'time_off') return 'time_off_management';

              return item;
            });
            this.roleData['manager'].push('manager');
            this.roleData['manager'].push('manager_coursework_management','manager_event_management');
          }else{
            this.roleData['manager'].push('manager_dashboard')
            this.roleData['manager'].push('manager');
          }
        }else{
          this.roleData['manager'].push('manager_dashboard')
          this.roleData['manager'].push('manager');
        }

        
      }
      sidebar_type = userObj["side_bar"]
      this.userAccessMenu = userObj["side_bar"]
    }
    let menuName = route.data['menuName'];
    if(this.loggedUserRole=="employee"){
      this.router.navigate(['/authentication/signin']);
      return false;
    }

   else  if ((this.loggedUserRole != 'employee') && this.roleData[this.loggedUserRole].includes(menuName)) {

      if (this.loggedUserRole == "company") {
        if (userObj.t_off == 0) {
          if (menuName == "manage_package") { return true }
          return false
        }
        else {
          if ((this.userAccessMenu[menuName] == 1 || menuName == "manage_package")) {
            return true;
          }
          else {
            // this.router.navigate(['/authentication/signin']);
            // if user is trying to change the url then also he should be redirected to login
            // user hasn't opted for user management  feature so, he can't access that page directly and was also not redirecting anywhere hence added the below code
            
            // this.appService.logOut()
            const dialogRef = this.dialog.open(AlertComponent, Object.assign({
              data: { api_type: 'please_buy', }
            }));
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
              }
            });
            return false
          }
        }
        return true
      }
      else {
        return true;
      }
    }
    else {
      // this.appService.logOut()
      this.router.navigate(['/authentication/signin']);
      return false;
    }
  }
}